<template>
	<div>
		<!-- Favoriten -->
		<FavoritesRegion></FavoritesRegion>

		<!-- Neuigkeiten -->
		<NewsRegion></NewsRegion>

		<!-- Angebote -->
		<HeadlineItem
			@click="$router.push('/angebote')"
			class="mt-8"
			title="NEW - Ihr Partner"
			subtitle="Angebote und Produkte"
			message="Im Schwimmunterricht für Ihren Nachwuchs, auf Ihrem Weg zur Arbeit oder für Kulturveranstaltungen in der Region. Wir sichern zuverlässig Ihre Energieversorgung Zuhause, helfen Ihnen, die richtige Infrastruktur für Ihr Elektroauto zu finden oder andere Modernisierungen anzugehen, um die Energiewende zu meistern.<br><br>Wir kümmern uns um Sie - jeden Tag!"
			:src="require('@/assets/imgs/products.png')"
		></HeadlineItem>

		<!-- Services -->
		<ServicesRegion></ServicesRegion>

		<!-- Eyecatcher -->
		<EyecatcherRegion></EyecatcherRegion>

		<!-- Highlight -->
		<HighlightRegion></HighlightRegion>

		<!-- Instagram -->
		<InstagramRegion></InstagramRegion>
	</div>
</template>
<script>
import HeadlineItem from "../components/design/HeadlineItem";
import ListView from "../components/design/ListView";

import EyecatcherRegion from "../components/regions/EyecatcherRegion";
import InstagramRegion from "../components/regions/InstagramRegion";
import FavoritesRegion from "@/components/regions/FavoritesRegion";
import ServicesRegion from "@/components/regions/ServicesRegion";
import NewsRegion from "@/components/regions/NewsRegion";
import HighlightRegion from "@/components/regions/HighlightRegion";

import { firebase, tracker } from "../main";
import axios from "axios";

export default {
	name: "App",
	data: () => ({
		recommended: ["loading"],
		apps: {
			loading: {
				loading: true,
			},
		},
		used: [],
		usedCustomerGroups: [],
		loadedRecommended: [],
		categories: {},
	}),
	methods: {
		clickApp(doc) {
			tracker.trackEvent("new_app", "open_dashboard", doc.id);
			if (doc.hasOwnProperty("href")) {
				window.open(doc.href, "_self");
			}
		},
	},
	computed: {
		isSignedIn() {
			return this.$store.getters.isSignedIn;
		},
	},
	watch: {
		isSignedIn(newVal, oldVal) {
			if (newVal == true) {
				this.$store.commit(
					"setCustomerGroups",
					Object.keys(loginNew.getProfile().categories)
				);
			} else {
				this.$store.commit("setCustomerGroups", []);
			}
		},
	},
	components: {
		HeadlineItem,
		ListView,
		InstagramRegion,
		FavoritesRegion,
		ServicesRegion,
		EyecatcherRegion,
		NewsRegion,
		HighlightRegion,
	},
};
</script>